import { render, staticRenderFns } from "./countrySwitcher.vue?vue&type=template&id=717df054"
import script from "./countrySwitcher.vue?vue&type=script&lang=ts"
export * from "./countrySwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports